module.exports = __webpack_public_path__ + "static/feature-multi-point-locking-5b7484382fbc98a441527eb05fc9eb11.png";